module.exports = __webpack_public_path__ + "static/img/fishGame1.0e9e73f.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/head/fishGame1.png
// module id = IEKK
// module chunks = 3